import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=422c4928&scoped=true"
import script from "./overview.vue?vue&type=script&lang=js"
export * from "./overview.vue?vue&type=script&lang=js"
import style0 from "./overview.vue?vue&type=style&index=0&id=422c4928&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422c4928",
  null
  
)

export default component.exports